














import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import dokument from '@/store/modules/dokument';
import Toggle from '@/views/document/section/Toggle.vue';
import Comment from '@/views/document/section/Comment.vue';

@Component({components: {Comment, Toggle}})
export default class Compass extends Vue {
  @Prop() readonly group!: any;

  comment: string = '';

  @Watch('section1', {immediate: false, deep: true})
  onData0() {
    this.onData();
  }
  @Watch('section2', {immediate: false, deep: true})
  onData1() {
    this.onData();
  }
  @Watch('section3', {immediate: false, deep: true})
  onData2() {
    this.onData();
  }
  @Watch('section4', {immediate: false, deep: true})
  onData3() {
    this.onData();
  }

  onData() {
    if (this.group.Hidden !== this.hidden) {
      const g = {
        Id: this.group.Id,
        Kind: this.group.Kind,
        Type: this.group.Type,
        SubType: this.group.SubType,
        Children: this.group.Children,
        Hidden: this.hidden,
      };
      dokument.updateItem(g);
    }
  }

  get section1(): any {
    return dokument.getItems(this.group.Id)[1];
  }

  get section2(): any {
    return dokument.getItems(this.group.Id)[2];
  }

  get section3(): any {
    return dokument.getItems(this.group.Id)[3];
  }

  get section4(): any {
    return dokument.getItems(this.group.Id)[4];
  }

  get hidden(): boolean {
    return this.section1.Hidden && this.section2.Hidden && this.section3.Hidden && this.section4.Hidden;
  }
}
